import { Button } from "@/components/ui/button";
import { UserPlus } from "lucide-react";

interface LeadActionsProps {
  pipelineStage: string;
  onConvert: (e: React.MouseEvent) => void;
}

export const LeadActions = ({ pipelineStage, onConvert }: LeadActionsProps) => {
  if (pipelineStage === 'Converted') {
    return null;
  }

  return (
    <Button 
      variant="outline" 
      size="sm" 
      className="w-full mt-2 border-gray-200 hover:bg-gray-50"
      onClick={onConvert}
    >
      <UserPlus className="h-4 w-4 mr-2" />
      Convert to Customer
    </Button>
  );
};